import store from './index'

    // On launch clear offline orders
export const initListener = () => {
    store.dispatch('orders/launchOfflineOrders')
    window.addEventListener('online', () => {
        store.dispatch('orders/launchOfflineOrders')
    })
}